import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useQuery, gql } from "@apollo/client";
import { useSpotify } from "../utils/useSpotify";
import { convertTime } from "../utils/index";
import Loader from "./common/Loader";
import Error from "./common/Error";
import "../styles/Profile.css";

const User = () => {
  const { token } = useSpotify();
  const { userId } = useParams();
  const GET_USER_PROFILE = gql`
    query UserProfile {
      getUserProfile(token: "${token}", id: "${userId}") {
        userTaste {
          key
          value
          info
        }
        name
        id
        userImageUrl
        topArtists {
          id
          name
          artistImageUrl
        }
        topTracks {
          id
          name
          trackImageUrl
        }
      }
    }
  `;
  const { loading, error, data } = useQuery(GET_USER_PROFILE);
  let userProfileData = data && data.getUserProfile;

  const [selectedInsight, setSelectedInsight] = useState("acousticness");
  const [insight, setInsight] = useState("");

  useEffect(() => {
    console.log(userProfileData);
    setInsight(
      userProfileData &&
        userProfileData.userTaste &&
        userProfileData.userTaste[0].info
    );
  }, [userProfileData]);

  const handleInsightClick = ({ key, info }) => {
    setSelectedInsight(key);
    setInsight(info);
  };

  if (loading) return <Loader />;
  else if (error) return <Error />;

  return (
    userProfileData && (
      <div className="wrapper">
        <div className="user-header">
          <div className="user-profile">
            <div className="user-image">
              <img
                src={userProfileData.userImageUrl || ""}
                alt=""
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://upload.wikimedia.org/wikipedia/commons/2/2c/Default_pfp.svg";
                }}
              />
            </div>
            <div className="name-header">
              <a
                className="user-name"
                // href={user?.external_urls?.spotify}
                target="_blank"
                rel="noopener noreferrer"
              >
                {userProfileData?.name}
              </a>
            </div>
          </div>
        </div>
        <div className="list-wrapper">
          <div className="list-header">
            <h2>Top Tracks</h2>
          </div>
          <ul className="list-content">
            {userProfileData?.topTracks?.map((item) => {
              const artistList =
                item?.artists?.map((artist) => artist.name) || [];
              return (
                <li key={item.id + "profile"} className="list-content-item">
                  <Link to={`/track/${item.id}`}>
                    <div className="item-image">
                      <img
                        src={item.trackImageUrl || ""}
                        alt=""
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://upload.wikimedia.org/wikipedia/commons/2/2c/Default_pfp.svg";
                        }}
                      />
                    </div>
                    <span className="item-name">{item.name}</span>
                    {/* <span className="item-name-sec">
                      {artistList.join(", ")}
                    </span>
                    <span className="item-name-sec">|</span>
                    <span className="item-name-sec">{item.album?.name}</span>
                    <span className="align-item-right item-name-sec">
                      {convertTime(item.duration_ms)}
                    </span> */}
                  </Link>
                </li>
              );
            })}
            {userProfileData?.topTracks?.length === 0 && (
              <li className="list-content-item">
                <span className="item-name">No Data</span>
              </li>
            )}
          </ul>
        </div>
        <div className="list-wrapper">
          <div className="list-header">
            <h2>Top Artists</h2>
          </div>
          <ul className="list-content">
            {userProfileData?.topArtists?.map((item) => {
              return (
                <li key={item.id + "profile"} className="list-content-item">
                  <Link to={`/artist/${item.id}`}>
                    <div className="item-image">
                      <img
                        src={item.artistImageUrl || ""}
                        alt=""
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src =
                            "https://upload.wikimedia.org/wikipedia/commons/2/2c/Default_pfp.svg";
                        }}
                      />
                    </div>
                    <span className="item-name">{item.name}</span>
                  </Link>
                </li>
              );
            })}
            {userProfileData?.topArtists?.length === 0 && (
              <li className="list-content-item">
                <span className="item-name">No Data</span>
              </li>
            )}
          </ul>
        </div>
        {/* <div className="list-wrapper">
          <div className="list-header">
            <h2>Top Genres</h2>
          </div>
          <div className="list-content-genre" direction="row" spacing={1}>
            {genres.map((genre) => (
              <div
                key={genre}
                className="list-content-genre-item"
                label={genre}
              >
                {genre}
              </div>
            ))}
          </div>
        </div> */}
        {userProfileData?.userTaste && userProfileData.userTaste[0]?.value && (
          <div className="list-wrapper">
            <div className="list-header">
              <h2>Profile Insights</h2>
            </div>
            <div className="profile-insight-grid-wrapper">
              <div className="profile-insight-grid">
                {userProfileData.userTaste.map((metadata) => {
                  return (
                    <div
                      className={
                        metadata.key === selectedInsight
                          ? "profile-insight active-profile-insight-card"
                          : "profile-insight"
                      }
                      onClick={(e) => handleInsightClick(metadata)}
                    >
                      <div className="profile-insight-detail-value">
                        {metadata.value}
                      </div>
                      <div className="profile-insight-detail-label">
                        {metadata.key[0].toUpperCase() + metadata.key.slice(1)}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            {insight && (
              <div id="insight" className="insight-info">
                {insight}
              </div>
            )}
          </div>
        )}
      </div>
    )
  );
};

export default User;
